const ADMIN_ENDPOINT='/api/v2/admin/audit';
const STRIPE_KEY='sk_live_FAKE_srcmap_ReconRange_7a3f';
export async function pull(){ return fetch(ADMIN_ENDPOINT,{headers:{Authorization:'Bearer '+STRIPE_KEY}}); }